<template>
  <div class="unit-edit">
    <el-form class="zwx-form" style="padding: 0 !important;" key="mainForm" ref="mainForm" :model="mainForm" :rules="rules" label-position="right">
      <!-- 基础信息部分 -->
      <headline title="基本信息" class="headline" />
      <el-divider class="base-divider" />
      <div style="max-width: 590px; padding: 10px 0 5px 20px !important;">
        <el-form-item label-width="126px" label="地区：" required>
          <zwx-select-area ref="zoneIdArea" @loadOver="zoneIdAreaLoadOver()" :zoneCode12From="zoneCode12From" :zoneTypeMax="zoneTypeMax" :zoneTypeMin="zoneTypeMin" :showFullName="false" :disabled="false" :clearable="false" />
        </el-form-item>
        <el-form-item label-width="84px" label="机构名称：" prop="unitName">
          <el-input class="zwx-input" v-model="mainForm.unitName" maxlength="100" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="126px" label="机构简称：">
          <el-input class="zwx-input" v-model="mainForm.unitAbb" maxlength="100" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="机构编码：">
          <el-input class="zwx-input" v-model="mainForm.unitCode" maxlength="30" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="126px" label="统一社会信用代码：" prop="socialCode">
          <el-input class="zwx-input" v-model="mainForm.socialCode" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="机构类型：">
          <code-select :codeType="unitTypeCodeTypeCode" v-model="mainForm.unitType" :clearable="true" />
        </el-form-item>
        <el-form-item label-width="126px" label="注册地址：">
          <el-input class="zwx-input" v-model="mainForm.unitAddr" maxlength="400" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="邮编：" prop="postCode">
          <el-input class="zwx-input" v-model="mainForm.postCode" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="126px" label="联系人：">
          <el-input class="zwx-input" v-model="mainForm.linkMan" maxlength="20" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="联系电话：" prop="linkTel">
          <el-input class="zwx-input" v-model="mainForm.linkTel" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="126px" label="联系人职务：">
          <el-input class="zwx-input" v-model="mainForm.linkDuty" maxlength="100" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="负责人：">
          <el-input class="zwx-input" v-model="mainForm.chargeMan" maxlength="20" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="126px" label="负责人电话：" prop="chargeTel">
          <el-input class="zwx-input" v-model="mainForm.chargeTel" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="负责人职务：">
          <el-input class="zwx-input" v-model="mainForm.chargeDuty" maxlength="100" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="126px" label="传真：">
          <el-input class="zwx-input" v-model="mainForm.unitFax" maxlength="20" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="邮箱：" prop="unitEmail">
          <el-input class="zwx-input" v-model="mainForm.unitEmail" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="126px" label="状态：" required>
          <el-radio-group class="zwx-radio-group" v-model="mainForm.ifEnable">
            <el-radio class="zwx-radio" :label="true">启用</el-radio>
            <el-radio class="zwx-radio" :label="false">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider" />
    <!-- 提交部分 -->
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-28" type="primary" @click="$system.valid($refs['mainForm'], '提示', '确定要提交吗？', '确定', '取消', commit)">提交</el-button>
      <el-button class="zwx-button zwx-button-28" @click="back()">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnitEdit',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      zoneCode12From: undefined,
      zoneTypeMax: undefined,
      zoneTypeMin: this.$route.params.zoneTypeMin,
      unitTypeCodeTypeCode: this.$route.params.unitTypeCodeTypeCode,
      mainForm: {
        fkByZoneId: { rid: '' },
        unitName: '',
        unitAbb: '',
        unitCode: '',
        socialCode: '',
        unitType: '',
        unitAddr: '',
        postCode: '',
        linkMan: '',
        linkTel: '',
        linkDuty: '',
        chargeMan: '',
        chargeTel: '',
        chargeDuty: '',
        unitFax: '',
        unitEmail: '',
        ifEnable: true,
      },
      rules: {
        unitName: [{ required: true, message: '请输入机构名称', trigger: ['change', 'blur'] }],
        socialCode: [{ required: false, validator: this.$validate.creditCode, trigger: ['change', 'blur'] }],
        postCode: [{ required: false, validator: this.$validate.zipCode, trigger: ['change', 'blur'] }],
        linkTel: [{ required: false, validator: this.$validate.mbPeLdline, trigger: ['change', 'blur'] }],
        chargeTel: [{ required: false, validator: this.$validate.mbPeLdline, trigger: ['change', 'blur'] }],
        unitEmail: [{ required: false, validator: this.$validate.email, trigger: ['change', 'blur'] }],
      },
    }
  },
  created() {
    this.zoneCode12From = this.users.ifSuperAdmin ? '000000000000' : this.users.fkByUnitId.fkByZoneId.zoneCode12
    this.zoneTypeMax = this.users.ifSuperAdmin ? '0' : (this.users.fkByUnitId.fkByZoneId.zoneType + 1).toString()
  },
  mounted() {
    this.detail()
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs
    },
  },
  methods: {
    detail() {
      this.$emit('loading', true)
      if (this.rid === undefined) {
        this.$refs.zoneIdArea.initSearch()
        return
      }
      let data = {
        rid: this.rid,
      }
      this.$system.get(this.api + '/systematic/getUnit-1', data, true, true, this.detailSuccess, this.detailError)
    },
    detailSuccess(data) {
      if (data.type === '00') {
        this.$refs.zoneIdArea.initSearch(data.unit.fkByZoneId.zoneCode12)
        this.mainForm.fkByZoneId.rid = data.unit.fkByZoneId.rid
        this.mainForm.unitName = data.unit.unitName
        this.mainForm.unitAbb = data.unit.unitAbb
        this.mainForm.unitCode = data.unit.unitCode
        this.mainForm.socialCode = data.unit.socialCode
        this.mainForm.unitType = data.unit.unitType
        this.mainForm.unitAddr = data.unit.unitAddr
        this.mainForm.postCode = data.unit.postCode
        this.mainForm.linkMan = data.unit.linkMan
        this.mainForm.linkTel = this.$zwxSm.sm4JsDecrypt(data.unit.linkTel)
        this.mainForm.linkDuty = data.unit.linkDuty
        this.mainForm.chargeMan = data.unit.chargeMan
        this.mainForm.chargeTel = this.$zwxSm.sm4JsDecrypt(data.unit.chargeTel)
        this.mainForm.chargeDuty = data.unit.chargeDuty
        this.mainForm.unitFax = data.unit.unitFax
        this.mainForm.unitEmail = data.unit.unitEmail
        this.mainForm.ifEnable = data.unit.ifEnable
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
        this.back()
      }
    },
    detailError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
      this.back()
    },
    zoneIdAreaLoadOver() {
      this.$emit('loading', false)
    },
    commit() {
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
        fkByZoneId: { rid: this.$refs.zoneIdArea.getChooseArea().rid },
        unitName: this.mainForm.unitName,
        unitAbb: this.mainForm.unitAbb,
        unitCode: this.mainForm.unitCode,
        socialCode: this.mainForm.socialCode,
        unitType: this.mainForm.unitType,
        unitAddr: this.mainForm.unitAddr,
        postCode: this.mainForm.postCode,
        linkMan: this.mainForm.linkMan,
        linkTel: this.mainForm.linkTel,
        linkDuty: this.mainForm.linkDuty,
        chargeMan: this.mainForm.chargeMan,
        chargeTel: this.mainForm.chargeTel,
        chargeDuty: this.mainForm.chargeDuty,
        unitFax: this.mainForm.unitFax,
        unitEmail: this.mainForm.unitEmail,
        ifEnable: this.mainForm.ifEnable,
      }
      this.$system.postJson(this.api + '/systematic/addOrModifyUnit-1', data, true, true, this.commitSuccess, this.commitError)
    },
    commitSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name, params: { fresh: true } })
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    commitError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
    back() {
      this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name })
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
